import { useMutation, useQueryClient } from "@tanstack/react-query";
import collectionApiClient from "../../../api/collection";

type DetachInput = { codeId: string; allowOffline?: boolean };

const useDetachCollectionCodeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ codeId, allowOffline }: DetachInput) =>
      collectionApiClient.detachCollectionCodeFromClock(codeId, allowOffline),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["collectionCodes"] });
    },
  });
};

export default useDetachCollectionCodeMutation;
